import { createContext, useContext } from 'react';
import type { ApolloQueryResult } from '@apollo/client';
import type { GetBoughtItemsQuery } from '../../utils/hooks/getBoughtItems';
type BoughtItemsRefetchContextType = {
  refetch: () => Promise<ApolloQueryResult<GetBoughtItemsQuery>>;
};
const BoughtItemsRefetchContext = createContext<BoughtItemsRefetchContextType | undefined>(undefined);
export const BoughtItemsRefetchProvider = BoughtItemsRefetchContext.Provider;
export const useBoughtItemsRefetch = () => {
  const context = useContext(BoughtItemsRefetchContext);
  if (!context) {
    throw new Error('useBoughtItemsRefetch must be used within BoughtItemsRefetchProvider');
  }
  return context;
};